import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import CustomBreadcrumb from '../../../components/base/CustomBreadcrumb';
import CustomListComponent from '../../../components/base/CustomListComponent';
import { createAction } from '../../../utils';
import ContentSections from '../../../components/base/ContentSections';
import {
  APIStatus,
} from '../../../config/CustomEnums';
import Loading from '../../../components/base/Loading';
import AuthButton from '../../../components/base/AuthButton';
import { PermissionCodes } from '../../../config/PermissionCodes';
import MembershipInfoCard from '../../../components/customer/MembershipInfoCard';

function GreetingSectionDetail({
  greetingSectionDetail,
  loadingStatus,
}) {
  const history = useHistory();
  const dispatch = useDispatch();
  const params = useParams();

  const sections = [
    loadingStatus === APIStatus.calling
      ? <Loading />
      : <MembershipInfoCard
        title="properties"
        data={greetingSectionDetail}
        fields={[
          [{ title: 'Name', field: 'name' }],
          [{ title: 'Background img style', field: 'backgroundImageStyle' }],
          [{ title: 'Custom image (Guest view)', field: 'backgroundImageGuestView' }],
          [{ title: 'Custom image (Signed-in view)', field: 'backgroundImageSignedInView' }],
          [{ title: 'Mission card style', field: 'missionCardStyle' }],
          [{ title: 'Active period', field: 'displayActivePeriod' }],
        ]}
      />,
  ]

  const tabs = [
    {
      name: 'Detail',
      content: (
        <ContentSections
          sections={sections}
          hidePreview
        />
      ),
    },
  ];

  const buttons =
    !greetingSectionDetail?.activeEndDate
      ? []
      : [
        <AuthButton
          title="Edit"
          action={() => {
            history.push({
              pathname: 'edit/',
            });
          }}
          requires={PermissionCodes.changeGreetingSection}
        />,
      ];

  const [activeTab, setActiveTab] = useState(tabs[0].name);

  useEffect(() => {
    if (params.id) {
      dispatch(
        createAction('greetingSection/getDetail')({ id: params.id }),
      );
    }
    return () => {
      dispatch({ type: 'greetingSection/clearData' });
    };
  }, [dispatch, params.id]);

  return (
    <div className="campaign-category-detail">
      <CustomListComponent
        caution={{
          detail: '',
          title: greetingSectionDetail?.name,
        }}
        defaultActiveKey={activeTab}
        breadcrumb={<CustomBreadcrumb name={greetingSectionDetail?.name} />}
        buttons={buttons}
        tabs={tabs}
        onTabChange={(key) => {
          setActiveTab(key);
        }}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  greetingSectionDetail: state.greetingSection.greetingSection,
  loadingStatus: state.greetingSection.loadingStatus,
});

export default connect(mapStateToProps)(GreetingSectionDetail);
